  ((window.theme = window.theme || {}),
  (window.theme = window.theme || {}),
  (theme.Sections = function () {
    ((this.constructors = {}),
      (this.instances = []),
      $(document)
        .on("shopify:section:load", this._onSectionLoad.bind(this))
        .on("shopify:section:unload", this._onSectionUnload.bind(this))
        .on("shopify:section:select", this._onSelect.bind(this))
        .on("shopify:section:deselect", this._onDeselect.bind(this))
        .on("shopify:block:select", this._onBlockSelect.bind(this))
        .on("shopify:block:deselect", this._onBlockDeselect.bind(this)));
  }),
  (theme.Sections.prototype = _.assignIn({}, theme.Sections.prototype, {
    _createInstance: function (e, t) {
      var i = $(e),
        n = i.attr("data-section-id"),
        a = i.attr("data-section-type");
      if (((t = t || this.constructors[a]), !_.isUndefined(t))) {
        var r = _.assignIn(new t(e), { id: n, type: a, container: e });
        this.instances.push(r);
      }
    },
    _onSectionLoad: function (e) {
      var t = $("[data-section-id]", e.target)[0];
      t && this._createInstance(t);
    },
    _onSectionUnload: function (e) {
      this.instances = _.filter(this.instances, function (t) {
        var i = t.id === e.detail.sectionId;
        return (i && _.isFunction(t.onUnload) && t.onUnload(e), !i);
      });
    },
    _onSelect: function (e) {
      var t = _.find(this.instances, function (t) {
        return t.id === e.detail.sectionId;
      });
      !_.isUndefined(t) && _.isFunction(t.onSelect) && t.onSelect(e);
    },
    _onDeselect: function (e) {
      var t = _.find(this.instances, function (t) {
        return t.id === e.detail.sectionId;
      });
      !_.isUndefined(t) && _.isFunction(t.onDeselect) && t.onDeselect(e);
    },
    _onBlockSelect: function (e) {
      var t = _.find(this.instances, function (t) {
        return t.id === e.detail.sectionId;
      });
      !_.isUndefined(t) && _.isFunction(t.onBlockSelect) && t.onBlockSelect(e);
    },
    _onBlockDeselect: function (e) {
      var t = _.find(this.instances, function (t) {
        return t.id === e.detail.sectionId;
      });
      !_.isUndefined(t) &&
        _.isFunction(t.onBlockDeselect) &&
        t.onBlockDeselect(e);
    },
    register: function (e, t) {
      ((this.constructors[e] = t),
        $("[data-section-type=" + e + "]").each(
          function (e, i) {
            this._createInstance(i, t);
          }.bind(this),
        ));
    },
  })),
  (window.slate = window.slate || {}),
  (slate.rte = {
    wrapTable: function () {
      $(".rte table").wrap('<div class="rte__table-wrapper"></div>');
    },
    iframeReset: function () {
      var e = $(
          '.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"]',
        ),
        t = e.add(".rte iframe#admin_bar_iframe");
      (e.each(function () {
        $(this).wrap('<div class="video-wrapper"></div>');
      }),
        t.each(function () {
          this.src = this.src;
        }));
    },
  }),
  (window.slate = window.slate || {}));
function gm_authFailure() {
  ($(".map-section").addClass("map-section--load-error"),
    $(".map-section__container").remove(),
    $(".map-section__link").remove(),
    $(".map-section__overlay").after(
      '<div class="errors tc">' + theme.strings.authError + "</div>",
    ));
}
var resizeTimer;
function htmlDecode(e) {
  return new DOMParser().parseFromString(e, "text/html").documentElement
    .textContent;
}
function getFocusableElements(e) {
  return Array.from(
    e.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe",
    ),
  );
}
((slate.a11y = {
  pageLinkFocus: function (e) {
    var t = "js-focus-hidden";
    e.first()
      .attr("tabIndex", "-1")
      .focus()
      .addClass(t)
      .one("blur", function () {
        e.first().removeClass(t).removeAttr("tabindex");
      });
  },
  focusHash: function () {
    var e = window.location.hash;
    e && document.getElementById(e.slice(1)) && this.pageLinkFocus($(e));
  },
  bindInPageLinks: function () {
    $("a[href*=#]").on(
      "click",
      function (e) {
        this.pageLinkFocus($(e.currentTarget.hash));
      }.bind(this),
    );
  },
  trapFocus: function (e) {
    var t = e.namespace ? "focusin." + e.namespace : "focusin";
    (e.$elementToFocus || (e.$elementToFocus = e.$container),
      e.$container.attr("tabindex", "-1"),
      e.$elementToFocus.focus(),
      $(document).off("focusin"),
      $(document).on(t, function (t) {
        e.$container[0] === t.target ||
          e.$container.has(t.target).length ||
          e.$container.focus();
      }));
  },
  removeTrapFocus: function (e) {
    var t = e.namespace ? "focusin." + e.namespace : "focusin";
    (e.$container && e.$container.length && e.$container.removeAttr("tabindex"),
      $(document).off(t));
  },
}),
  (theme.Images = {
    preload: function (e, t) {
      "string" == typeof e && (e = [e]);
      for (var i = 0; i < e.length; i++) {
        var n = e[i];
        this.loadImage(this.getSizedImageUrl(n, t));
      }
    },
    loadImage: function (e) {
      new Image().src = e;
    },
    switchImage: function (e, t, i) {
      var n = this.imageSize(t.src),
        a = this.getSizedImageUrl(e.src, n);
      i ? i(a, e, t) : (t.src = a);
    },
    imageSize: function (e) {
      var t = e.match(
        /.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/,
      );
      return null !== t ? t[1] : null;
    },
    getSizedImageUrl: function (e, t) {
      if (null == t) return e;
      if ("master" === t) return this.removeProtocol(e);
      var i = e.match(
        /\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif|webp|heic)(\?v=\d+)?$/i,
      );
      if (null != i) {
        var n = e.split(i[0]),
          a = i[0];
        return this.removeProtocol(n[0] + "_" + t + a);
      }
      return null;
    },
    removeProtocol: function (e) {
      return e.replace(/http(s)?:/, "");
    },
  }),
  (theme.Currency = {
    formatMoney: function (e, t) {
      "string" == typeof e && (e = e.replace(".", ""));
      var i = "",
        n = /\{\{\s*(\w+)\s*\}\}/,
        a = t || "${{amount}}";
      function r(e, t, i, n) {
        if (
          ((t = t || 2), (i = i || ","), (n = n || "."), isNaN(e) || null == e)
        )
          return 0;
        var a = (e = (e / 100).toFixed(t)).split(".");
        return (
          a[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + i) +
          (a[1] ? n + a[1] : "")
        );
      }
      switch (a.match(n)[1]) {
        case "amount":
          i = r(e, 2);
          break;
        case "amount_no_decimals":
          i = r(e, 0);
          break;
        case "amount_with_comma_separator":
          i = r(e, 2, ".", ",");
          break;
        case "amount_no_decimals_with_comma_separator":
          i = r(e, 0, ".", ",");
          break;
        case "amount_no_decimals_with_space_separator":
          i = r(e, 0, " ");
      }
      return a.replace(n, i);
    },
  }),
  (slate.Variants = (function () {
    function e(e) {
      ((this.$container = e.$container),
        (this.product = e.product),
        (this.singleOptionSelector = e.singleOptionSelector),
        (this.originalSelectorId = e.originalSelectorId),
        (this.enableHistoryState = e.enableHistoryState),
        (this.currentVariant = this._getVariantFromOptions()),
        $(this.singleOptionSelector, this.$container).on(
          "change",
          this._onSelectChange.bind(this),
        ));
    }
    return (
      (e.prototype = _.assignIn({}, e.prototype, {
        _getCurrentOptions: function () {
          var e = _.map(
            $(this.singleOptionSelector, this.$container),
            function (e) {
              var t = $(e),
                i = t.attr("type"),
                n = t.parents(".product-form"),
                a = {};
              return "radio" === i || "checkbox" === i
                ? !!t[0].checked &&
                    ((a.value = t.val()),
                    (a.index = t.data("index")),
                    $(n)
                      .find("." + a.index)
                      .find(".slVariant")
                      .text(a.value),
                    a)
                : ((a.value = t.val()),
                  (a.index = t.data("index")),
                  $(n)
                    .find("." + a.index)
                    .find(".slVariant")
                    .text(a.value),
                  a);
            },
          );
          return (e = _.compact(e));
        },
        _getVariantFromOptions: function () {
          var e = this._getCurrentOptions(),
            t = this.product.variants;
          return _.find(t, function (t) {
            return e.every(function (e) {
              return _.isEqual(t[e.index], e.value);
            });
          });
        },
        _onSelectChange: function () {
          var e = this._getVariantFromOptions();
          (this.$container.trigger({ type: "variantChange", variant: e }),
            e &&
              (this._updateMasterSelect(e),
              this._updateImages(e),
              this._updatePrice(e),
              this._updateSKU(e),
              (this.currentVariant = e),
              this.enableHistoryState && this._updateHistoryState(e)));
        },
        _updateImages: function (e) {
          var t = e.featured_image || {},
            i = this.currentVariant.featured_image || {};
          e.featured_image &&
            t.src !== i.src &&
            this.$container.trigger({ type: "variantImageChange", variant: e });
        },
        _updatePrice: function (e) {
          (e.price === this.currentVariant.price &&
            e.compare_at_price === this.currentVariant.compare_at_price) ||
            this.$container.trigger({ type: "variantPriceChange", variant: e });
        },
        _updateSKU: function (e) {
          e.sku !== this.currentVariant.sku &&
            this.$container.trigger({ type: "variantSKUChange", variant: e });
        },
        _updateHistoryState: function (e) {
          if (history.replaceState && e) {
            var t =
              window.location.protocol +
              "//" +
              window.location.host +
              window.location.pathname +
              "?variant=" +
              e.id;
            window.history.replaceState({ path: t }, "", t);
          }
        },
        _updateMasterSelect: function (e) {
          $(this.originalSelectorId, this.$container).val(e.id);
        },
      })),
      e
    );
  })()),
  (window.theme = window.theme || {}),
  (theme.Header = {
    init: function () {
      ($(".site-settings").on("click", function (e) {
        (e.preventDefault(), $("#settingsBox").toggleClass("active"));
      }),
        $(".hasSub").hover(function (e) {
          var t = $(this).data("link"),
            i = $(this).closest(".mmWrapper");
          ($(i)
            .find(".admmsub:not(" + t + ")")
            .removeClass("active"),
            $(i).find(".hasSub").removeClass("active"),
            $(t).addClass("active"),
            $(this).addClass("active"));
        }),
        $("#siteNav .lvl1 > a").each(function () {
          $(this).attr("href") == window.location.pathname &&
            $(this).addClass("active");
        }),
        $(".js-mobile-nav-toggle, .closemmn").on("click", function () {
          ($(".mobile-nav-wrapper").toggleClass("active"),
            $("body").toggleClass("menuOn"),
            $(".js-mobile-nav-toggle").toggleClass("open close"));
        }),
        $("#MobileNav .at, .sidebar_cate .at").on("click", function (e) {
          (e.preventDefault(),
            $(this).toggleClass("at-plus-l at-minus-l"),
            $(this).parent().next().slideToggle());
        }),
        $("body").click(function (e) {
          var t = $(e.target);
          (t.parents().is(".mobile-nav-wrapper") ||
            t.parents().is(".js-mobile-nav-toggle") ||
            t.is(".js-mobile-nav-toggle") ||
            ($(".mobile-nav-wrapper").removeClass("active"),
            $("body").removeClass("menuOn"),
            $(".js-mobile-nav-toggle").removeClass("close").addClass("open")),
            t.parents().is("#settingsBox") ||
              t.parents().is(".site-settings") ||
              t.is(".site-settings") ||
              $("#settingsBox").removeClass("active"),
            t.parents().is(".filterbar") ||
              t.is(".filterbar") ||
              t.is(".btn-filter") ||
              $(".filterbar.active").removeClass("active"));
        }));
    },
  }),
  (window.theme = window.theme || {}),
  (theme.Search = {
    init: function () {
      ($('form[action="/search"]').each(function () {
        var e = $(this).find('input[name="q"]');
        ($("#unprod").val(),
          e.bind("keyup change", function () {
            var e = $(this).val(),
              t = $(this).closest("form").find(".search-results");
            e.length > 2
              ? fetch(
                  `${routes.predictive_search_url}?q=${e}&section_id=predictive-search`,
                )
                  .then((e) => {
                    if (!e.ok) {
                      var i = new Error(e.status);
                      throw ($(t).hide(), $(".s_suggestion").fadeIn(), i);
                    }
                    return e.text();
                  })
                  .then((e) => {
                    (new DOMParser()
                      .parseFromString(e, "text/html")
                      .querySelector("#shopify-section-predictive-search")
                      .innerHTML,
                      $(t).html(e).fadeIn(),
                      $(".s_suggestion").hide());
                  })
                  .catch((e) => {
                    throw ($(t).hide(), $(".s_suggestion").show(), e);
                  })
              : (t.empty().hide(), $(".s_suggestion").show());
          }));
      }),
        $(".modalOverly, .closeSearch").bind("click", function () {
          ($("body").removeClass("showOverly"),
            $("#searchPopup").removeClass("active"));
        }),
        $(".searchIco").on("click", function (e) {
          (e.preventDefault(),
            $("body").addClass("showOverly"),
            $("#searchPopup").addClass("active"),
            $("input[name=q]").focus());
        }));
    },
  }),
  (window.theme = window.theme || {}),
  (theme.HeaderSection = (function () {
    function e() {
      (theme.Header.init(), theme.Search.init());
    }
    return (
      (e.prototype = _.assignIn({}, e.prototype, {
        onUnload: function () {
          theme.Header.unload();
        },
      })),
      e
    );
  })()),
  (theme.Maps = (function () {
    var e = 14,
      t = null,
      i = [],
      n = theme.mapKey ? theme.mapKey : "";
    function a(e) {
      ((this.$container = $(e)),
        "loaded" === t
          ? this.createMap()
          : (i.push(this),
            "loading" !== t &&
              ((t = "loading"),
              void 0 === window.google &&
                $.getScript(
                  "https://maps.googleapis.com/maps/api/js?key=" + n,
                ).then(function () {
                  ((t = "loaded"),
                    $.each(i, function (e, t) {
                      t.createMap();
                    }));
                }))));
    }
    return (
      (a.prototype = _.assignIn({}, a.prototype, {
        createMap: function () {
          var t = this.$container.find(".map-section__container");
          return (function (e) {
            var t = $.Deferred(),
              i = new google.maps.Geocoder(),
              n = e.data("address-setting");
            return (
              i.geocode({ address: n }, function (e, i) {
                (i !== google.maps.GeocoderStatus.OK && t.reject(i),
                  t.resolve(e));
              }),
              t
            );
          })(t)
            .then(
              function (i) {
                var n = {
                    zoom: e,
                    center: i[0].geometry.location,
                    disableDefaultUI: !0,
                  },
                  a = (this.map = new google.maps.Map(t[0], n));
                ((this.center = a.getCenter()),
                  new google.maps.Marker({ map: a, position: a.getCenter() }));
                google.maps.event.addDomListener(window, "resize");
              }.bind(this),
            )
            .fail(function () {
              var e;
              switch (status) {
                case "ZERO_RESULTS":
                  e = theme.strings.addressNoResults;
                  break;
                case "OVER_QUERY_LIMIT":
                  e = theme.strings.addressQueryLimit;
                  break;
                default:
                  e = theme.strings.addressError;
              }
              t.parent()
                .addClass("page-width map-section--load-error")
                .html('<div class="errors tc">' + e + "</div>");
            });
        },
        onUnload: function () {
          google.maps.event.clearListeners(this.map, "resize");
        },
      })),
      a
    );
  })()),
  (theme.Product = (function () {
    function e(e) {
      this.container = e;
      var t = (this.$container = $(e)),
        i = t.attr("data-section-id");
      ((this.settings = {
        mediaQueryMediumUp: "screen and (min-width: 768px)",
        mediaQuerySmall: "screen and (max-width: 767px)",
        bpSmall: !1,
        enableHistoryState: t.data("enable-history-state") || !1,
        imageSize: null,
        imageZoomSize: null,
        namespace: ".slideshow-" + i,
        sectionId: i,
        sliderActive: !1,
        zoomEnabled: !1,
      }),
        (this.selectors = {
          purl: t.attr("data-url"),
          mainSec: i,
          addToCart: "#AddToCart-" + i,
          discountBadge: ".bdg" + i,
          SKU: ".variant-sku",
          productPrices: "#price" + i,
          originalSelectorId: "#ProductSelect-" + i,
          ftImg: ".featImg" + i,
          imgWrap: ".pr_zoom_" + i,
          primgsl: ".pis" + i,
          thumbsWr: ".ptw" + i,
          thumbs: ".pr_thumbs" + i,
          thumbImg: ".pr_thumb" + i,
          singleOptionSelector: ".single-option-selector-" + i,
          productMediaWrapper: "[data-product-single-media-wrapper]",
          productMediaTypeModel: "[data-product-media-type-model]",
        }),
        $(".stickyOpt .selectedOpt").on("click", function () {
          $(".stickyOpt ul").slideToggle("fast");
        }),
        $(".stickyOpt .vrOpt").on("click", function (e) {
          var t = $(this).data("no");
          ($(".stickyOpt .selectedOpt").html($(this).html()),
            $(".stickyOpt ul").slideUp("fast"),
            (this.productvariants = JSON.parse(
              document.getElementById("ProductJson-" + i).innerHTML,
            )));
          var n = this.productvariants.variants[t].options;
          if ($("select.single-option-selector").length) {
            if (null != n[1]) {
              var a = n[1].replace(/'/g, "\\'");
              $(".single-option-selector:eq(1)").val(a);
            }
            if (null != n[2]) {
              var r = n[2].replace(/'/g, "\\'");
              $(".single-option-selector:eq(2)").val(r);
            }
            if (null != n[0]) {
              var s = n[0].replace(/'/g, "\\'");
              $(".single-option-selector:eq(0)").val(s).trigger("change");
            }
          } else {
            if (null != n[1]) {
              a = n[1].replace(/'/g, "\\'");
              $(".swatchInput[value='" + a + "']").prop("checked", !0);
            }
            if (null != n[2]) {
              r = n[2].replace(/'/g, "\\'");
              $(".swatchInput[value='" + r + "']").prop("checked", !0);
            }
            if (null != n[0]) {
              s = n[0].replace(/'/g, "\\'");
              $(".swatchInput[value='" + s + "']").trigger("click");
            }
          }
        }),
        $(".stickyQty .qtyBtn").on("click", function () {
          var e = $("#quantity"),
            t = $(e).val(),
            i = 1;
          ($(this).is(".plus")
            ? (i = parseInt(t) + 1)
            : t > 1 && (i = parseInt(t) - 1),
            $(e).val(i).trigger("change"));
        }),
        $("#quantity").on("change", function () {
          $("#quantity1").val($(this).val());
        }),
        "undefined" != typeof variantImages &&
          $(this.selectors.thumbImg).bind("click", function () {
            var e = $(this).attr("href").split("?")[0].split("."),
              t = e.pop(),
              i = e.pop().replace(/_[a-zA-Z0-9@]+$/, ""),
              n = e.join(".") + "." + i + "." + t;
            void 0 !== variantImages[n] &&
              productOptions.forEach(function (e, t) {
                ((optionValue = variantImages[n]["option-" + t]),
                  $(".swatch.pvOpt0").length
                    ? null !== optionValue &&
                      $(".pvOpt" + t + " .swatchInput").filter(function () {
                        return $(this).val() === optionValue;
                      }).length &&
                      $(".pvOpt" + t)
                        .find('.swatchInput[value="' + optionValue + '"]')
                        .prop("checked", !0)
                        .trigger("change")
                    : null !== optionValue &&
                      $(".single-option-selector:eq(" + t + ") option").filter(
                        function () {
                          return $(this).text() === optionValue;
                        },
                      ).length &&
                      $(".single-option-selector:eq(" + t + ")")
                        .val(optionValue)
                        .trigger("change"));
              });
          }),
        $(".product-info .review").on("click", function (e) {
          ($(".product-tabs li").removeClass("active"),
            $(".tablink[href='#ptabReview']").parent().addClass("active"),
            $(".tab-content").not("#ptabReview").css("display", "none"),
            $("#ptabReview").fadeIn());
          var t = $("#ptabReview").offset();
          $(window).width() < 767
            ? $("html, body").animate({ scrollTop: t.top - 100 }, 700)
            : $("html, body").animate({ scrollTop: t.top - 150 }, 700);
        }),
        $("#ProductJson-" + i).html() &&
          ((this.productSingleObject = JSON.parse(
            document.getElementById("ProductJson-" + i).innerHTML,
          )),
          (this.settings.zoomEnabled = $(this.selectors.ftImg).hasClass(
            "js-zoom-enabled",
          )),
          (this.settings.imageSize = theme.Images.imageSize(
            $(this.selectors.ftImg).attr("src"),
          )),
          this._initBreakpoints(),
          this._stringOverrides(),
          this._initVariants(),
          this._initImageSwitch(),
          this._initThumbnailSlider(),
          this._setActiveThumbnail(),
          this._initModelViewerLibraries(),
          theme.Images.preload(
            this.productSingleObject.images,
            this.settings.imageSize,
          )));
    }
    return (
      (e.prototype = _.assignIn({}, e.prototype, {
        _stringOverrides: function () {
          ((theme.productStrings = theme.productStrings || {}),
            $.extend(theme.strings, theme.productStrings));
        },
        _initBreakpoints: function () {
          var e = this;
          (enquire.register(this.settings.mediaQuerySmall, {
            match: function () {
              var t;
              (e.settings.zoomEnabled &&
                ((t = $(e.selectors.productImageWrap)),
                $(t).each(function () {
                  $(this).trigger("zoom.destroy");
                })),
                (e.settings.bpSmall = !0));
            },
            unmatch: function () {
              e.settings.bpSmall = !1;
            },
          }),
            enquire.register(this.settings.mediaQueryMediumUp, {
              match: function () {
                var t;
                e.settings.zoomEnabled &&
                  ((t = $(e.selectors.imgWrap)),
                  $(t).hover(
                    function () {
                      var e = $(this).data("zoom");
                      $(this).zoom({ url: e });
                    },
                    function () {
                      $(this).trigger("zoom.destroy");
                    },
                  ));
              },
            }));
        },
        _initVariants: function () {
          var e = {
            $container: this.$container,
            enableHistoryState:
              this.$container.data("enable-history-state") || !1,
            singleOptionSelector: this.selectors.singleOptionSelector,
            originalSelectorId: this.selectors.originalSelectorId,
            product: this.productSingleObject,
          };
          ((this.variants = new slate.Variants(e)),
            this.$container.on(
              "variantChange" + this.settings.namespace,
              this._updateAddToCart.bind(this),
            ),
            this.$container.on(
              "variantImageChange" + this.settings.namespace,
              this._updateImages.bind(this),
            ),
            this.$container.on(
              "variantPriceChange" + this.settings.namespace,
              this._updatePrice.bind(this),
            ),
            this.$container.on(
              "variantSKUChange" + this.settings.namespace,
              this._updateSKU.bind(this),
            ));
        },
        _initImageSwitch: function () {
          if ($(this.selectors.thumbImg).length) {
            var e = this;
            $(this.selectors.thumbImg).on("click", function (t) {
              t.preventDefault();
              var i = $(this).attr("href");
              e._setActiveThumbnail(i);
            });
          }
        },
        _setActiveThumbnail: function (e) {
          void 0 === e &&
            (e = $(this.selectors.thumbImg + ".activeSlide").attr("href"));
          var t = $(this.selectors.thumbImg + '[href="' + e + '"]'),
            i = t.parent().index();
          if (
            "style3" == theme.productStrings.prStyle ||
            "style4" == theme.productStrings.prStyle ||
            "style5" == theme.productStrings.prStyle
          ) {
            var n = $(".pr_photo[data-slide='" + i + "']").offset();
            $(window).width() > 767
              ? $("html, body").animate({ scrollTop: n.top - 70 }, 700)
              : $(this.selectors.primgsl).flickity("select", i);
          } else
            $(this.selectors.primgsl).flickity("select", t.parent().index());
          $(".stickCtImg").attr("src", e);
        },
        _initThumbnailSlider: function () {
          var e = $(this.selectors.thumbsWr),
            t = $(this.selectors.thumbs),
            i = t.find(".pr_thumbs_item"),
            n = $(this.selectors.primgsl).data("flickity"),
            a = (t.position().top, t.position().left, i.height()),
            r = i.width(),
            s = t.height(),
            o = t.width();
          $(this.selectors.primgsl).on("select.flickity", function () {
            t.find(".active-thumb").removeClass("active-thumb");
            var c = i.eq(n.selectedIndex).addClass("active-thumb");
            if ($(".thumbs_nav.bottom").length || $(window).width() < 767) {
              var l = c.position().left + e.scrollLeft() - (o + r) / 2.5;
              e.animate({ scrollLeft: l });
            } else {
              var d = c.position().top + t.scrollTop() - (s + a) / 2.5;
              t.animate({ scrollTop: d });
            }
          });
          var c = $(this.selectors.primgsl);
          ($(".thumbs_nav .previous").on("click", function () {
            c.flickity("previous");
          }),
            $(".thumbs_nav .next").on("click", function () {
              c.flickity("next");
            }),
            $(window).on("load", function (e) {
              (c.flickity("resize"),
                $('.pr_thumb[data-slide="0"] .prvideo').trigger("click"));
              var t = $(".primgSlider .videoSlide.is-selected video").get(0);
              $(t).length && t.play();
            }),
            c.on("change.flickity", function (e, t) {
              $(this).find(".videoSlide video").length &&
                $(this).find(".videoSlide video").get(0).pause();
              var i = $(this).find(".videoSlide.is-selected video").get(0);
              $(i).length && i.play();
              var n = $(this).data("flickity");
              $(this).find(".is-selected model-viewer").length
                ? ((n.options.draggable = !1),
                  n.updateDraggable(),
                  $(
                    ".is-selected .shopify-model-viewer-ui__button--poster",
                  ).trigger("click"))
                : ((n.options.draggable = !0), n.updateDraggable());
            }));
        },
        _initModelViewerLibraries: function () {
          var e = this.container.querySelectorAll(
            this.selectors.productMediaTypeModel,
          );
          e.length < 1 || theme.ProductModel.init(e, this.settings.sectionId);
        },
        _updateAddToCart: function (e) {
          var t = e.variant,
            i = this.selectors.addToCart;
          if (t)
            if (
              ($(".selectedOpt").html(
                $('.vrOpt[data-val="' + t.id + '"]').html(),
              ),
              t.available)
            ) {
              var n = $("#pvr-" + t.id).text(),
                a = $("#quantity_message").data("qty");
              ($(i).prop("disabled", !1),
                n < 1 && "shopify" == t.inventory_management
                  ? $(i).find(".txt").text(theme.strings.preOrder)
                  : $(i).find(".txt").text(theme.strings.addToCart),
                n < 1 && "shopify" == t.inventory_management
                  ? $(".stockLbl")
                      .removeClass("instock outstock")
                      .addClass("preorder")
                      .text($(".stockLbl").data("pre"))
                  : $(".stockLbl")
                      .removeClass("preorder outstock")
                      .addClass("instock")
                      .text($(".stockLbl").data("in")),
                n < a && 0 != n && "shopify" == t.inventory_management
                  ? $("#quantity_message").show().find(".items").text(n)
                  : $("#quantity_message").hide(),
                $(".backStock").addClass("hide"));
            } else r();
          else r();
          function r(e) {
            ($(i).prop("disabled", !0),
              $(i).find(".txt").text(theme.strings.unavailable),
              $(".stockLbl")
                .removeClass("preorder instock")
                .addClass("outstock")
                .text($(".stockLbl").data("out")),
              $("#quantity_message").hide(),
              $(".backStock").removeClass("hide"));
          }
        },
        _updateImages: function (e) {
          var t = e.variant,
            i = theme.Images.getSizedImageUrl(
              t.featured_media.preview_image.src,
              this.settings.imageSize,
            );
          this._setActiveThumbnail(i);
        },
        _updatePrice: function (e) {
          var t = e.variant;
          fetch(
            this.selectors.purl +
              "?variant=" +
              t.id +
              "&section_id=" +
              this.selectors.mainSec,
          )
            .then((e) => e.text())
            .then((e) => {
              var t = new DOMParser().parseFromString(e, "text/html"),
                i = document.getElementById("price" + this.selectors.mainSec),
                n = t.getElementById("price" + this.selectors.mainSec);
              (n && i && (i.innerHTML = n.innerHTML),
                theme.mlcurrency &&
                  currenciesChange(
                    this.selectors.productPrices + " span.money",
                  ));
              var a = document.getElementById("invens"),
                r = t.getElementById("invens");
              r && a && (a.innerHTML = r.innerHTML);
            });
        },
        _updateSKU: function (e) {
          var t = e.variant;
          $(this.selectors.SKU).html(t.sku);
        },
        onUnload: function () {
          this.$container.off(this.settings.namespace);
        },
      })),
      e
    );
  })()),
  (theme.ProductModel = (function () {
    var e = {},
      t = {},
      i = {},
      n = "[data-product-single-media-group]",
      a = "[data-shopify-xr]";
    function r(t) {
      if (!t)
        if (window.ShopifyXR) {
          for (var i in e)
            if (e.hasOwnProperty(i)) {
              var n = e[i];
              if (n.loaded) continue;
              var a = document.querySelector("#ModelJson-" + i);
              (window.ShopifyXR.addModels(JSON.parse(a.innerHTML)),
                (n.loaded = !0));
            }
          window.ShopifyXR.setupXRElements();
        } else
          document.addEventListener("shopify_xr_initialized", function () {
            r();
          });
    }
    function s(e) {
      if (!e)
        for (var i in t)
          if (t.hasOwnProperty(i)) {
            var n = t[i];
            n.modelViewerUi ||
              (n.modelViewerUi = new Shopify.ModelViewerUI(n.element));
          }
    }
    return {
      init: function (o, c) {
        ((e[c] = { loaded: !1 }),
          o.forEach(function (e, r) {
            var s = e.getAttribute("data-media-id"),
              o = e.querySelector("model-viewer"),
              l = o.getAttribute("data-model-id");
            if (0 === r) {
              var d = e.closest(n).querySelector(a);
              i[c] = { element: d, defaultId: l };
            }
            t[s] = { modelId: l, sectionId: c, container: e, element: o };
          }),
          window.Shopify.loadFeatures([
            { name: "shopify-xr", version: "1.0", onLoad: r },
            { name: "model-viewer-ui", version: "1.0", onLoad: s },
          ]),
          theme.LibraryLoader.load("modelViewerUiStyles"));
      },
      removeSectionModels: function (i) {
        for (var n in t) {
          if (t.hasOwnProperty(n))
            t[n].sectionId === i && (t[n].modelViewerUi.destroy(), delete t[n]);
        }
        delete e[i];
      },
    };
  })()),
  (theme.LibraryLoader = (function () {
    var e = "link",
      t = "script",
      i = { requested: "requested", loaded: "loaded" },
      n = {
        modelViewerUiStyles: {
          tagId: "shopify-model-viewer-ui-styles",
          src: "https://cdn.shopify.com/shopifycloud/model-viewer-ui/assets/v1.0/model-viewer-ui.css",
          type: e,
        },
      };
    return {
      load: function (a, r) {
        var s = n[a];
        if (s && s.status !== i.requested)
          if (((r = r || function () {}), s.status !== i.loaded)) {
            var o;
            switch (((s.status = i.requested), s.type)) {
              case t:
                o = (function (e, t) {
                  var n = document.createElement("script");
                  return (
                    (n.src = e.src),
                    n.addEventListener("load", function () {
                      ((e.status = i.loaded), t());
                    }),
                    n
                  );
                })(s, r);
                break;
              case e:
                o = (function (e, t) {
                  var n = document.createElement("link");
                  return (
                    (n.href = e.src),
                    (n.rel = "stylesheet"),
                    (n.type = "text/css"),
                    n.addEventListener("load", function () {
                      ((e.status = i.loaded), t());
                    }),
                    n
                  );
                })(s, r);
            }
            ((o.id = s.tagId), (s.element = o));
            var c = document.getElementsByTagName(s.type)[0];
            c.parentNode.insertBefore(o, c);
          } else r();
      },
    };
  })()),
  (theme.tabs = function (e) {
    (this.$container = $(e)).attr("data-section-id");
    var t = (this.tabs = ".product-tabs .tablink");
    ($(t).on("click", function (e) {
      (e.preventDefault(),
        $(this).parent().addClass("active").siblings().removeClass("active"));
      var t = $(this).attr("href");
      ($(".tab-content").not(t).css("display", "none"), $(t).fadeIn());
    }),
      $(".acor-ttl .tablink").on("click", function (e) {
        if (
          (e.preventDefault(),
          $(this).parent().toggleClass("active").next().slideToggle(),
          $(window).width() < 767)
        ) {
          var t = $(this).offset();
          $("html, body").animate({ scrollTop: t.top - 80 }, 500);
        }
      }),
      $(".product-tabs li:first-child,.tab-container h3:first-child").addClass(
        "active",
      ),
      $(".tab-container h3:first-child + .tab-content").show());
  }),
  (theme.QuickView = void $("body").on("click", ".quick-view", function (e) {
    ($.ajax({
      beforeSend: function () {
        $("body").addClass("loading");
      },
      url: $(this).attr("href"),
      success: function (e) {
        $.magnificPopup.open({
          items: {
            src:
              '<div class="quick-view-popup mfpbox mfp-with-anim" id="content_quickview">' +
              e +
              "</div>",
            type: "inline",
          },
          removalDelay: 500,
          callbacks: {
            beforeOpen: function () {
              ($(".stickyHeader").addClass("popup"),
                (this.st.mainClass = "mfp-zoom-in"));
            },
            open: function () {
              shopreviews();
            },
            close: function () {
              ($(".stickyHeader").removeClass("popup"),
                $("#content_quickview").empty());
            },
          },
        });
      },
      complete: function () {
        $("body").removeClass("loading");
      },
    }),
      e.preventDefault(),
      e.stopPropagation());
  })),
  (theme.quotesl = {}),
  (theme.Quotes = function (e) {
    var t = (this.$container = $(e)).attr("data-section-id"),
      i = (this.quotesl = "#Quotes-" + t);
    if (Shopify.designMode) {
      var n = $(i).attr("data-flickity");
      i.length &&
        ($(i).flickity(JSON.parse(n)),
        setTimeout(function () {
          $(i).flickity("resize");
        }));
    }
  }),
  (theme.slideshows = {}),
  (theme.SlideshowSection = (function () {
    function e(e, t, i) {
      if (e[0]) {
        var n,
          a,
          r = $(i),
          s = r.width(),
          o = r.height();
        t = t || 16 / 9;
        e.each(function () {
          var e = $(this);
          s / t < o
            ? ((n = Math.ceil(o * t)),
              e
                .width(n)
                .height(o)
                .css({ left: (s - n) / 2, top: 0 }))
            : ((a = Math.ceil(s / t)),
              e
                .width(s)
                .height(a)
                .css({ left: 0, top: (o - a) / 2 }));
        });
      }
    }
    return function (t) {
      var i = (this.$container = $(t)).attr("data-section-id"),
        n = (this.slideshow = "#ss" + i);
      $(n).flickity();
      var a = $(n).find(".embed-player");
      (e(a, 16 / 9, $(n)),
        $(window).on("resize", function () {
          e(a, 16 / 9, $(n));
        }));
    };
  })()),
  (theme.collectionView = function (e) {
    var t = (this.$container = $(e));
    (t.attr("data-section-id"),
      t.attr("data-section-timeout"),
      $(document).on("change", "#SortBySt", function (e) {
        var t = $(this).val();
        $("#CollectionFiltersForm").length
          ? $("#SortBy").val(t).trigger("change")
          : t.length
            ? (window.location.search = "sort_by=" + t)
            : (window.location.href = window.location.href.replace(
                window.location.search,
                "",
              ));
      }),
      $(document).on("click", ".change-view", function (e) {
        var t = $(this).data("view"),
          i = document.URL,
          n = new URL(i);
        n.searchParams.set("view", t);
        var a = n.href;
        window.location = a;
      }),
      $(document).on("change", ".optTag", function (e) {
        var t = $(".sidebar_tags").data("url"),
          i = window.location.search.substring(1),
          n = $("input.optTag"),
          a = [];
        if (
          (n.each(function () {
            $(this).val() &&
              1 == $(this).is(":checked") &&
              a.push($(this).val());
          }),
          a.length)
        ) {
          var r = a.join("+");
          ajaxfilter(t + "/" + r + "?" + i);
        } else ajaxfilter(t + "?" + i);
      }),
      $(document).on(
        "change",
        ".flForm .custCheck, .prRange, #SortBy",
        function (e) {
          var t = "//" + window.location.hostname + window.location.pathname,
            i = $("#CollectionFiltersForm").serialize();
          ajaxfilter(t + "?" + i);
        },
      ),
      $(document).on("click", "a.actFilter", function (e) {
        e.preventDefault();
        var t = "//" + window.location.hostname + $(this).attr("href");
        ajaxfilter(t);
      }),
      $(document).on("click", "span.actFilter", function () {
        var e = $(this).attr("data-value");
        $(".filterBox input[value='" + e + "']").trigger("click");
      }),
      $(".flbytags").each(function () {
        $(this).find("li").length <= 0 && $(this).hide();
      }),
      (ajaxfilter = function (e) {
        $.ajax({
          type: "GET",
          url: e,
          data: {},
          beforeSend: function () {
            $("body").addClass("loading hideOverly");
          },
          complete: function (t) {
            ($(".productList .grid-products").html(
              $(".productList .grid-products", t.responseText).html(),
            ),
              $(".filters-toolbar__product-count").html(
                $(".filters-toolbar__product-count", t.responseText).html(),
              ),
              $(".sidebar_tags").html(
                $(".sidebar_tags", t.responseText).html(),
              ),
              $(".active-facets").html(
                $(".active-facets", t.responseText).html(),
              ),
              $(".pagination").html($(".pagination", t.responseText).html()),
              $(".pagination", t.responseText).html()
                ? $(".pagination").show()
                : $(".pagination").hide(),
              $(".infinitpaginOuter").html(
                $(".infinitpaginOuter", t.responseText).html(),
              ),
              $(".infinitpaginOuter", t.responseText).html() ||
                $(".infinitpagin").remove(),
              theme.mlcurrency && currenciesChange("sapn.money"),
              $("body").removeClass("loading hideOverly"),
              $(".infinitpagin a.infinite").length && infiniteScroll(),
              loadMoreBtn(),
              $(".prRange").length && priceSlider(),
              $("#sideProdSlider").length && $("#sideProdSlider").flickity(),
              history.pushState({ page: e }, e, e));
          },
        });
      }),
      (infiniteScroll = function () {
        var e = "scroll load";
        $(window).on(e, function () {
          var t = $(".infinitpagin a").attr("href");
          if ($(".infinitpagin a.infinite").length) {
            var i = $(".infinitpagin").offset();
            $(document).scrollTop() + $(window).height() - 50 > i.top &&
              ($(window).off(e), loadMore(t));
          }
        });
      }),
      (loadMoreBtn = function () {
        $(document).on("click", ".infinitpagin a.loadMore", function (e) {
          e.preventDefault();
          var t = $(this).attr("href");
          loadMore(t);
        });
      }),
      (loadMore = function (e) {
        e.length &&
          $.ajax({
            type: "GET",
            dataType: "html",
            url: e,
            beforeSend: function () {
              "button" == $(".infinitpaginOuter").attr("data-type")
                ? $("body").addClass("loading hideOverly")
                : $(".infinitpagin a").show();
            },
            complete: function (e) {
              ($(".productList .grid-products").length
                ? $(".productList .grid-products").append(
                    $(".productList .grid-products", e.responseText).html(),
                  )
                : $(".productList .list-view-items").append(
                    $(".productList .list-view-items", e.responseText).html(),
                  ),
                $(".infinitpagin", e.responseText).html()
                  ? $(".infinitpagin").html(
                      $(".infinitpagin", e.responseText).html(),
                    )
                  : $(".infinitpagin").remove(),
                theme.mlcurrency && currenciesChange("sapn.money"),
                $(".infinitpagin a.infinite").length && infiniteScroll(),
                $("body").removeClass("loading hideOverly"));
            },
          });
      }),
      $(document).ready(function () {
        (infiniteScroll(), loadMoreBtn());
      }));
  }),
  (theme.instagramSection = function (e) {
    var t = (this.$container = $(e)),
      i = t.attr("data-section-id"),
      n = t.attr("data-act"),
      a = t.attr("data-count");
    $.ajax({
      url:
        "https://graph.instagram.com/me/media?fields=id,media_type,media_url,permalink,thumbnail_url,caption,children&access_token=" +
        n,
      type: "GET",
      dataType: "json",
      success: function (e) {
        var t = e.data,
          n = "#instafeed" + i,
          r = "";
        if (
          ($.each(t, function (e, t) {
            if (e >= a) return 0;
            var i = t.thumbnail_url || t.media_url;
            r +=
              '<div class="gitem insta-img"><a rel="nofollow" class="instagram-" href="' +
              t.permalink +
              '" target="_blank"><img data-src="' +
              i +
              '" alt="" class="lazyload" /></a></div>';
          }),
          $(n).html(r),
          $("#instafeed" + i + ".carousel").length)
        ) {
          var s =
            $("#instafeed" + i + ".carousel").attr("data-flickity1") || "{}";
          new Flickity("#instafeed" + i + ".carousel", JSON.parse(s));
        }
      },
    });
  }),
  (theme.slcarousel = {}),
  (theme.carousel = function (e) {
    var t = (this.$container = $(e)),
      i = t.attr("data-section-id"),
      n =
        ((this.slcarousel = $(t).find(".carousel")),
        (this.tabs = "#" + i + " .tablink")),
      a = (this.tabcontent = "#" + i + " .tab-content");
    if (Shopify.designMode) {
      var r = this.slcarousel.attr("data-flickity");
      this.slcarousel.length &&
        (this.slcarousel.flickity(JSON.parse(r)),
        setTimeout(function () {
          $(".carousel").flickity("resize");
        }));
    }
    $(n).on("click", function (e) {
      (e.preventDefault(),
        $(this).parent().addClass("active").siblings().removeClass("active"));
      var t = $(this).attr("href");
      ($(a).not(t).css("display", "none"),
        $(t).fadeIn().find(".carousel").flickity("resize"));
    });
  }),
  (theme.masonary = function (e) {
    var t = (this.$container = $(e)),
      i = t.attr("data-section-id"),
      n = (this.masonary = $(t).find(".grid-masonary"));
    function a(e) {
      $(e).masonry({
        columnWidth: ".grid-sizer-" + i,
        itemSelector: ".ms-item",
        percentPosition: !0,
      });
    }
    (a(n),
      setTimeout(function () {
        a(n);
      }, 1e3));
  }),
  (theme.ajaxCart = function () {
    function e() {
      if (
        null != localStorage.getItem("wishlist") &&
        "+" != localStorage.getItem("wishlist")
      )
        for (
          var e = String(localStorage.getItem("wishlist")).split("+"), t = 0;
          t < e.length;
          t++
        )
          "" != e[t] &&
            ($('.wishlist[rel="' + e[t] + '"]')
              .removeClass("addto-wishlist")
              .find("span")
              .text(theme.wlAvailable),
            $('.wishlist[rel="' + e[t] + '"] .at')
              .removeClass("at-heart-l")
              .addClass("at-heart"),
            $(".favCount").text(t).removeClass("hide"));
    }
    ($(document).on("click touch", ".quickShop", function (e) {
      (e.preventDefault(), e.stopImmediatePropagation());
      var t = $(this).attr("href"),
        i = $(this).parents(".grid-view-item").find(".gview-img"),
        n = $(this).parents(".grid-view-item").find(".shopWrapper");
      $.ajax({
        url: t + "/?section_id=quick-shop",
        dataType: "html",
        type: "GET",
        beforeSend: function () {
          ($(i).append("<i class='at at-spinner4 at-spin'></i>"),
            $(i).addClass("showLoading"));
        },
        success: function (e) {
          ($(".shopWrapper").removeClass("active").html(""),
            $(n).addClass("active").html(e));
        },
        complete: function (e) {
          ($(i).removeClass("showLoading"),
            $(i).find(".at-spinner4").remove(),
            theme.mlcurrency &&
              currenciesChange(".shopWrapper.active .priceSingle span.money"));
        },
      });
    }),
      $(document).on("click touch", ".closeShop", function (e) {
        (e.preventDefault(),
          $(this).parents(".shopWrapper").removeClass("active"));
      }),
      $(document).on("click", ".wishlist", function (t) {
        t.preventDefault();
        var $el = $(this);
        var i = $el.attr("rel");
        if ($el.hasClass("addto-wishlist")) {
          if (null == localStorage.getItem("wishlist")) var n = "+" + i;
          else
            -1 == localStorage.getItem("wishlist").indexOf(i) &&
              (n = (n = localStorage.wishlist + "+" + i).replace("++", "+"));
          (localStorage.setItem("wishlist", n),
            $el
              .find(".at")
              .removeClass("at-heart-l")
              .addClass("at-circle-notch-r at-spin"),
            setTimeout(function () {
              ($('.wishlist[rel="' + i + '"]')
                .removeClass("addto-wishlist")
                .find("span")
                .text(theme.wlAvailable),
                $('.wishlist[rel="' + i + '"] .at')
                  .removeClass("at-circle-notch-r at-spin")
                  .addClass("at-heart"),
                e());
            }, 1500));
        } else {
          $el
            .find(".at")
            .removeClass("at-heart")
            .addClass("at-circle-notch-r at-spin");
          setTimeout(function () {
            var currentWishlist = localStorage.getItem("wishlist") || "";
            currentWishlist = currentWishlist.replace(i, "").replace("++", "+");
            if (currentWishlist == "+" || currentWishlist == "") {
              localStorage.removeItem("wishlist");
              $(".favCount").addClass("hide").text("0");
            } else {
              localStorage.setItem("wishlist", currentWishlist);
              var items = currentWishlist.split("+").filter(Boolean);
              $(".favCount").text(items.length);
            }
            $('.wishlist[rel="' + i + '"]')
              .addClass("addto-wishlist")
              .find("span")
              .text(theme.wlAddTo || "Add to Wishlist");
            $('.wishlist[rel="' + i + '"] .at')
              .removeClass("at-circle-notch-r at-spin at-heart")
              .addClass("at-heart-l");
            e();
          }, 1500);
        }
      }),
      e(),
      $(".continue-shopping, .modalOverly, .closeDrawer").click(function () {
        ($(".modal").fadeOut(200), $("body").removeClass("loading showOverly"));
      }),
      $(document).on("click", ".add-to-cart", function (e) {
        (e.preventDefault(),
          $("body").addClass("loading"),
          $(this).next().find(".cartBtn").trigger("click"));
      }),
      $(document).on("click", ".mbCart", function (e) {
        (e.preventDefault(),
          $("body")
            .addClass("overflow-hidden")
            .find(".ctdrawer")
            .addClass("active"));
      }));
  }),
  window.addEventListener("DOMContentLoaded", function () {
    $(theme.ajaxCart);
  }),
  $(document).ready(function () {
    var e = new theme.Sections();
    (e.register("header-section", theme.HeaderSection),
      e.register("product", theme.Product),
      e.register("collection-template", theme.collectionView),
      e.register("product-template", theme.Product),
      e.register("productTabs", theme.tabs),
      e.register("map", theme.Maps),
      e.register("slideshow-section", theme.SlideshowSection),
      e.register("carousel", theme.carousel),
      e.register("quotes", theme.Quotes),
      e.register("masonary", theme.masonary),
      e.register("instagram", theme.instagramSection));
  }),
  $(window).resize(function () {
    (clearTimeout(resizeTimer),
      (resizeTimer = setTimeout(function () {
        $(window).trigger("delayed-resize");
      }, 250)));
  }),
  (theme.countdown = function () {
    $(".saleTime, .atCounter").each(function () {
      var e = $(this),
        t = $(this).data("date"),
        i = new Date(t).getTime(),
        n = setInterval(function () {
          var t = new Date().getTime(),
            a = i - t,
            r = Math.floor(a / 864e5),
            s = Math.floor((a % 864e5) / 36e5),
            o = Math.floor((a % 36e5) / 6e4),
            c = Math.floor((a % 6e4) / 1e3);
          ((r = ("00" + r).substr(r > 99 ? -3 : -2)),
            (s = ("00" + s).substr(-2)),
            (o = ("00" + o).substr(-2)),
            (c = ("00" + c).substr(-2)),
            $(e).find(".days").html(r),
            $(e).find(".hours").html(s),
            $(e).find(".minutes").html(o),
            $(e).find(".seconds").html(c),
            a < 0 && (clearInterval(n), $(e).hide().parents(".timerl").hide()));
        }, 1e3);
    });
  }),
  (theme.init = function () {
    (slate.rte.wrapTable(),
      slate.rte.iframeReset(),
      theme.countdown(),
      slate.a11y.pageLinkFocus($(window.location.hash)),
      $(".in-page-link").on("click", function (e) {
        slate.a11y.pageLinkFocus($(e.currentTarget.hash));
      }),
      $('a[href="#"]').on("click", function (e) {
        e.preventDefault();
      }));
  }),
  $(theme.init),
  $(document).ready(function () {
    "use strict";
    ($(document).on("click", ".currencyOpt", function (e) {
      ($("#CurrencySelector").val($(this).data("value")),
        $("#localization_form").submit());
    }),
      $(document).on("click", ".clOtp", function (e) {
        var t = $(this).parents("form");
        ($(t).find(".slcrlg").val($(this).data("value")), $(t).submit());
      }),
      $(".btn-shop").click(function () {
        ($(".products .list-columns, .grid-lookbook").removeClass("active"),
          $(this).next().addClass("active"),
          $(this).parents(".grid-lookbook").addClass("active"));
      }),
      $(".btn-shop-close").click(function () {
        $(this).parent().removeClass("active");
      }),
      "true" == getCookie("promotion") && $(".notification-bar").slideUp(),
      $(".close-announcement").click(function () {
        ($(".notification-bar").slideUp(), setCookie("promotion", "true", 1));
      }),
      $(document).on("click touch", ".btn-filter, .closeFilter", function () {
        $(".filterbar").toggleClass("active");
      }),
      $("body").click(function (e) {
        var t = $(e.target);
        t.parents().is(".sb_filter") ||
          t.is(".sb_filter") ||
          t.is(".btn-filter") ||
          $(".sb_filter").removeClass("active");
      }),
      (window.onscroll = function () {
        !(function () {
          theme.fixedHeader &&
            ($(window).scrollTop() > 145
              ? ($("#header").addClass("stickyHeader animated fadeInDown"),
                $(".stickySpace").css("min-height", $("#header").height()))
              : ($("#header").removeClass("stickyHeader fadeInDown"),
                $(".stickySpace").css("min-height", "")));
          var e = $(".stickyCart").height(),
            t = $(".mbtlwraper").height();
          (console.log(t),
            $(window).scrollTop() > 600 && $(".stickyCart").length
              ? "" != t
                ? ($("body.template-product").css("padding-bottom", e + t),
                  $(".stickyCart").slideDown(),
                  $(".stickyCart").css("bottom", t))
                : ($("body.template-product").css("padding-bottom", e),
                  $(".stickyCart").slideDown())
              : ($("body.template-product").css("padding-bottom", "0"),
                $(".stickyCart").slideUp()));
          $(window).scrollTop() > 200
            ? $("#site-scroll").fadeIn()
            : $("#site-scroll").fadeOut();
        })();
      }),
      $("#site-scroll").click(function () {
        return ($("html, body").animate({ scrollTop: 0 }, 1e3), !1);
      }),
      $(".footer-links .h4").click(function () {
        $(window).width() < 750 &&
          ($(this).toggleClass("active"), $(this).next().slideToggle());
      }),
      $(document).on("click", ".gridSwatches li:not(.noImg)", function (e) {
        var t = $(this),
          i = $(this).attr("rel"),
          n = $(this).parents(".grid-view-item").find(".gimg-link");
        $(n)
          .find(".variantImg")
          .css("background-image", "url('" + i + "')");
        var a = document.createElement("img");
        return (
          (a.src = i),
          (a.onload = function () {
            ($(n).addClass("showVariantImg"),
              t.siblings().removeClass("active"),
              t.addClass("active"));
          }),
          !1
        );
      }),
      $(".mfp-link").magnificPopup({
        delegate: ".mfp",
        removalDelay: 300,
        callbacks: {
          beforeOpen: function () {
            ($(".stickyHeader").addClass("popup"),
              (this.st.mainClass = this.st.el.attr("data-effect")));
          },
          close: function () {
            $(".stickyHeader").removeClass("popup");
          },
        },
        midClick: !0,
      }));
  }),
  document.querySelectorAll(".mtmltxt").forEach(function (e) {
    e.innerHTML = htmlDecode(e.innerHTML);
  }));
class QuantityInput extends HTMLElement {
  constructor() {
    (super(),
      (this.input = this.querySelector("input")),
      (this.changeEvent = new Event("change", { bubbles: !0 })),
      this.querySelectorAll(".qtyBtn").forEach((e) =>
        e.addEventListener("click", this.onButtonClick.bind(this)),
      ));
  }
  onButtonClick(e) {
    e.preventDefault();
    var t = this.input.value;
    ("plus" === e.currentTarget.name ? this.input.stepUp() : this.input.stepDown(),
      t !== this.input.value && this.input.dispatchEvent(this.changeEvent));
  }
}
function debounce(e, t) {
  var i;
  return (...n) => {
    (clearTimeout(i), (i = setTimeout(() => e.apply(this, n), t)));
  };
}
function fetchConfig(e = "json") {
  return {
    method: "POST",
    headers: { "Content-Type": "application/json", Accept: `application/${e}` },
  };
}
function removeTrapFocus(e = null) {
  (document.removeEventListener("focusin", trapFocusHandlers.focusin),
    document.removeEventListener("focusout", trapFocusHandlers.focusout),
    document.removeEventListener("keydown", trapFocusHandlers.keydown),
    e && e.focus());
}
customElements.define("quantity-input", QuantityInput);
var trapFocusHandlers = {};
function trapFocus(e, t = e) {
  var i = getFocusableElements(e),
    n = i[0],
    a = i[i.length - 1];
  (removeTrapFocus(),
    (trapFocusHandlers.focusin = (t) => {
      (t.target !== e && t.target !== a && t.target !== n) ||
        document.addEventListener("keydown", trapFocusHandlers.keydown);
    }),
    (trapFocusHandlers.focusout = function () {
      document.removeEventListener("keydown", trapFocusHandlers.keydown);
    }),
    (trapFocusHandlers.keydown = function (t) {
      "TAB" === t.code.toUpperCase() &&
        (t.target !== a || t.shiftKey || (t.preventDefault(), n.focus()),
        (t.target !== e && t.target !== n) ||
          !t.shiftKey ||
          (t.preventDefault(), a.focus()));
    }),
    document.addEventListener("focusout", trapFocusHandlers.focusout),
    document.addEventListener("focusin", trapFocusHandlers.focusin),
    t.focus());
}
class CartRemoveButton extends HTMLElement {
  constructor() {
    (super(),
      this.addEventListener("click", (e) => {
        (e.preventDefault(),
          (
            this.closest("cart-items") || this.closest("cart-drawer-items")
          ).updateQuantity(this.dataset.index, 0));
      }));
  }
}
customElements.define("cart-remove-button", CartRemoveButton);
class CartItems extends HTMLElement {
  constructor() {
    (super(),
      (this.lineItemStatusElement =
        document.getElementById("shopping-cart-line-item-status") ||
        document.getElementById("CartDrawer-LineItemStatus")),
      (this.currentItemCount = Array.from(
        this.querySelectorAll('[name="updates[]"]'),
      ).reduce((e, t) => e + parseInt(t.value), 0)),
      (this.debouncedOnChange = debounce((e) => {
        this.onChange(e);
      }, 300)),
      this.addEventListener("change", this.debouncedOnChange.bind(this)));
  }
  onChange(e) {
    e.target.classList.contains("stopEv") ||
      this.updateQuantity(
        e.target.dataset.index,
        e.target.value,
        document.activeElement.getAttribute("name"),
      );
  }
  getSectionsToRender() {
    return [
      {
        id: "main-cart-items",
        section: document.getElementById("main-cart-items").dataset.id,
        selector: ".js-contents",
      },
      {
        id: "main-cart-footer",
        section: document.getElementById("main-cart-footer").dataset.id,
        selector: ".cartTotal",
      },
    ];
  }
  updateQuantity(e, t, i) {
    this.enableLoading(e);
    var n = JSON.stringify({
      line: e,
      quantity: t,
      sections: this.getSectionsToRender().map((e) => e.section),
      sections_url: window.location.pathname,
    });
    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), body: n })
      .then((e) => e.text())
      .then((t) => {
        var n = JSON.parse(t),
          a =
            document.getElementById(`Quantity-${e}`) ||
            document.getElementById(`Drawer-quantity-${e}`);
        this.classList.toggle("is-empty", 0 === n.item_count);
        var r = document.querySelector("cart-drawer"),
          s = document.getElementById("main-cart-footer");
        (n.errors &&
          ((a.value = a.getAttribute("value")),
          this.updateLiveRegions(e, "none")),
          s && s.classList.toggle("is-empty", 0 === n.item_count),
          r && r.classList.toggle("is-empty", 0 === n.item_count),
          this.getSectionsToRender().forEach((e) => {
            (
              document.getElementById(e.id).querySelector(e.selector) ||
              document.getElementById(e.id)
            ).innerHTML = this.getSectionInnerHTML(
              n.sections[e.section],
              e.selector,
            );
          }),
          this.updateLiveRegions(e, n.item_count));
        var o =
          document.getElementById(`CartItem-${e}`) ||
          document.getElementById(`CartDrawer-Item-${e}`);
        (o && o.querySelector(`[name="${i}"]`)
          ? r
            ? trapFocus(r, o.querySelector(`[name="${i}"]`))
            : o.querySelector(`[name="${i}"]`).focus()
          : 0 === n.item_count && r
            ? trapFocus(
                r.querySelector(".drawer__inner-empty"),
                r.querySelector("a"),
              )
            : document.querySelector(".cart-item") &&
              r &&
              trapFocus(r, document.querySelector(".cart-item__name")),
          this.disableLoading());
      })
      .catch(() => {
        (this.querySelectorAll(".loading-overlay").forEach((e) =>
          e.classList.add("hidden"),
        ),
          ((
            document.getElementById("cart-errors") ||
            document.getElementById("CartDrawer-CartErrors")
          ).textContent = window.cartStrings.error),
          this.disableLoading());
      });
  }
  updateLiveRegions(e, t) {
    if (this.currentItemCount === t || "none" == t) {
      var i =
          document.getElementById(`Line-item-error-${e}`) ||
          document.getElementById(`CartDrawer-LineItemError-${e}`),
        n =
          document.getElementById(`Quantity-${e}`) ||
          document.getElementById(`Drawer-quantity-${e}`);
      (i.classList.add("error-alert"),
        (i.querySelector(".ctItem-error").innerHTML =
          window.cartStrings.quantityError.replace("[quantity]", n.value)));
    }
    ((this.currentItemCount = t),
      this.lineItemStatusElement.setAttribute("aria-hidden", !0));
    var a =
      document.getElementById("cart-live-region-text") ||
      document.getElementById("CartDrawer-LiveRegionText");
    (a.setAttribute("aria-hidden", !1),
      freeShippMsg(),
      setTimeout(() => {
        a.setAttribute("aria-hidden", !0);
      }, 1e3));
  }
  getSectionInnerHTML(e, t) {
    return new DOMParser().parseFromString(e, "text/html").querySelector(t)
      .innerHTML;
  }
  enableLoading(e) {
    ((
      document.getElementById("main-cart-items") ||
      document.getElementById("CartDrawer-CartItems")
    ).classList.add("cart__items--disabled"),
      [
        ...this.querySelectorAll(`#CartItem-${e} .loading-overlay`),
        ...this.querySelectorAll(`#CartDrawer-Item-${e} .loading-overlay`),
      ].forEach((e) => e.classList.remove("hidden")),
      document.activeElement.blur(),
      this.lineItemStatusElement.setAttribute("aria-hidden", !1));
  }
  disableLoading() {
    (
      document.getElementById("main-cart-items") ||
      document.getElementById("CartDrawer-CartItems")
    ).classList.remove("cart__items--disabled");
  }
}
(customElements.define("cart-items", CartItems),
  customElements.get("cart-note") ||
    customElements.define(
      "cart-note",
      class extends HTMLElement {
        constructor() {
          (super(),
            this.addEventListener(
              "change",
              debounce((e) => {
                var t = JSON.stringify({ note: e.target.value });
                fetch(`${routes.cart_update_url}`, {
                  ...fetchConfig(),
                  body: t,
                });
              }, 300),
            ));
        }
      },
    ));
class CartDrawer extends HTMLElement {
  constructor() {
    (super(),
      this.addEventListener(
        "keyup",
        (e) => "Escape" === e.code && this.close(),
      ),
      this.querySelector("#CartDrawer-Overlay").addEventListener(
        "click",
        this.close.bind(this),
      ),
      this.setHeaderCartIconAccessibility());
  }
  setHeaderCartIconAccessibility() {
    var e = document.querySelector("#cartLink");
    (e.setAttribute("role", "button"),
      e.setAttribute("aria-haspopup", "dialog"),
      e.addEventListener("click", (t) => {
        (t.preventDefault(), this.open(e));
      }),
      e.addEventListener("keydown", (t) => {
        "SPACE" === t.code.toUpperCase() && (t.preventDefault(), this.open(e));
      }));
  }
  open(e) {
    e && this.setActiveElement(e);
    var t = this.querySelector('[id^="Details-"] summary');
    (t && !t.hasAttribute("role") && this.setSummaryAccessibility(t),
      setTimeout(() => {
        this.classList.add("active");
      }),
      this.addEventListener(
        "transitionend",
        () => {
          trapFocus(
            this.classList.contains("is-empty")
              ? this.querySelector(".drawer__inner-empty")
              : document.getElementById("CartDrawer"),
            this.querySelector(".drawer__inner") ||
              this.querySelector(".drawer__close"),
          );
        },
        { once: !0 },
      ),
      document.body.classList.add("overflow-hidden"),
      document.body.classList.remove("loading"));
  }
  close() {
    (this.classList.remove("active"),
      removeTrapFocus(this.activeElement),
      document.body.classList.remove("overflow-hidden"));
  }
  setSummaryAccessibility(e) {
    (e.setAttribute("role", "button"),
      e.setAttribute("aria-expanded", "false"),
      e.nextElementSibling.getAttribute("id") &&
        e.setAttribute("aria-controls", e.nextElementSibling.id),
      e.addEventListener("click", (e) => {
        e.currentTarget.setAttribute(
          "aria-expanded",
          !e.currentTarget.closest("details").hasAttribute("open"),
        );
      }));
  }
  renderContents(e) {
    (this.querySelector(".drawer__inner").classList.contains("is-empty") &&
      this.querySelector(".drawer__inner").classList.remove("is-empty"),
      (this.productId = e.id),
      this.getSectionsToRender().forEach((t) => {
        (t.selector
          ? document.querySelector(t.selector)
          : document.getElementById(t.id)
        ).innerHTML = this.getSectionInnerHTML(e.sections[t.id], t.selector);
      }),
      setTimeout(() => {
        (this.querySelector("#CartDrawer-Overlay").addEventListener(
          "click",
          this.close.bind(this),
        ),
          this.open());
      }));
  }
  getSectionInnerHTML(e, t = ".shopify-section") {
    return new DOMParser().parseFromString(e, "text/html").querySelector(t)
      .innerHTML;
  }
  getSectionsToRender() {
    return [{ id: "cart-drawer", selector: "#CartDrawer" }];
  }
  getSectionDOM(e, t = ".shopify-section") {
    return new DOMParser().parseFromString(e, "text/html").querySelector(t);
  }
  setActiveElement(e) {
    this.activeElement = e;
  }
}
customElements.define("cart-drawer", CartDrawer);
class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      { id: "CartDrawer", section: "cart-drawer", selector: ".drawer__inner" },
    ];
  }
}
customElements.define("cart-drawer-items", CartDrawerItems);
class CouponCode extends HTMLElement {
  constructor() {
    (super(),
      localStorage.getItem("storedDiscount") &&
        (this.querySelector('input[name="discount"]').value =
          localStorage.getItem("storedDiscount")),
      this.querySelector("[data-update-coupon]").addEventListener(
        "click",
        (e) => {
          ((this.val = this.querySelector('input[name="discount"]').value),
            localStorage.setItem("storedDiscount", this.val),
            fetch(`/discount/${this.val}`)
              .then((e) => e.text())
              .then((e) => {}),
            document.querySelector("#cartCoupon") &&
              document.querySelector("#cartCoupon").classList.remove("active"));
        },
      ));
  }
}
customElements.define("coupon-code", CouponCode);
class CartOption extends HTMLElement {
  constructor() {
    (super(),
      this.querySelectorAll(".cftBtn").forEach((e) =>
        e.addEventListener("click", function (e) {
          e.preventDefault();
          var t = this.hash.substr(1);
          ($(".cftDraw.active").removeClass("active"),
            document.getElementById(t).classList.add("active"));
        }),
      ),
      document.querySelectorAll(".saveBtn").forEach((e) =>
        e.addEventListener("click", function (e) {
          document.querySelectorAll(".cftDraw").forEach((e) => {
            e.classList.remove("active");
          });
        }),
      ));
  }
}
function startTimer(e, t) {
  var i,
    n,
    a = e;
  setInterval(function () {
    ((i = parseInt(a / 60, 10)),
      (n = parseInt(a % 60, 10)),
      (i = i < 10 ? "0" + i : i),
      (n = n < 10 ? "0" + n : n),
      (t.textContent = i + ":" + n),
      --a < 0 &&
        (clearInterval(startTimer),
        document.querySelector(".cartCountdown").remove()));
  }, 1e3);
}
function freeShippMsg() {
  fetch(window.routes.url + "/?section_id=cart-template")
    .then((e) => e.text())
    .then((e) => {
      var t = new DOMParser().parseFromString(e, "text/html"),
        i = document.querySelector("#CartCount"),
        n = t.querySelector("#cartItems");
      if (
        (n && i && (i.innerHTML = n.innerHTML),
        document.querySelector(".freeShipMsg"))
      ) {
        var a = document.querySelector(".freeShipMsg"),
          r = t.querySelector(".freeShipget");
        (r && a && (a.innerHTML = r.innerHTML),
          theme.mlcurrency && currenciesChange(".freeShipMsg span.money"));
      }
    });
}
function shopreviews() {
  $(".spr-badge").length &&
    (SPR.registerCallbacks(),
    SPR.initRatingHandler(),
    SPR.initDomEls(),
    SPR.loadProducts(),
    SPR.loadBadges());
}
(customElements.define("cart-option", CartOption),
  (window.onload = function () {
    document.querySelector(".cartCountdown") &&
      startTimer(
        document.querySelector(".cartCountdown").getAttribute("data-countdown"),
        document.querySelector("#cartTime"),
      );
  }),
  customElements.get("product-form") ||
    customElements.define(
      "product-form",
      class extends HTMLElement {
        constructor() {
          (super(),
            (this.form = this.querySelector("form")),
            (this.form.querySelector("[name=id]").disabled = !1),
            this.form.addEventListener(
              "submit",
              this.onSubmitHandler.bind(this),
            ),
            (this.cart = document.querySelector("cart-drawer")),
            (this.submitButton = this.querySelector('[type="submit"]')),
            document.querySelector("cart-drawer") &&
              this.submitButton.setAttribute("aria-haspopup", "dialog"));
        }
        onSubmitHandler(e) {
          if (
            (e.preventDefault(),
            "true" !== this.submitButton.getAttribute("aria-disabled"))
          ) {
            (this.handleErrorMessage(),
              this.submitButton.setAttribute("aria-disabled", !0),
              this.submitButton.classList.add("loading"),
              this.querySelector(".loading-overlay__spinner").classList.remove(
                "hidden",
              ));
            var t = fetchConfig("javascript");
            ((t.headers["X-Requested-With"] = "XMLHttpRequest"),
              delete t.headers["Content-Type"]);
            var i = new FormData(this.form);
            (this.cart &&
              (i.append(
                "sections",
                this.cart.getSectionsToRender().map((e) => e.id),
              ),
              i.append("sections_url", window.location.pathname),
              this.cart.setActiveElement(document.activeElement)),
              (t.body = i),
              fetch(`${routes.cart_add_url}`, t)
                .then((e) => e.json())
                .then((e) => {
                  if (e.status) {
                    this.handleErrorMessage(e.description);
                    var t =
                      this.submitButton.querySelector(".sold-out-message");
                    if (!t) return;
                    return (
                      this.submitButton.setAttribute("aria-disabled", !0),
                      this.submitButton
                        .querySelector("span")
                        .classList.add("hidden"),
                      t.classList.remove("hidden"),
                      void (this.error = !0)
                    );
                  }
                  if (this.cart) {
                    this.error = !1;
                    var i = this.closest("quick-add-modal");
                    i
                      ? (document.body.addEventListener(
                          "modalClosed",
                          () => {
                            setTimeout(() => {
                              this.cart.renderContents(e);
                            });
                          },
                          { once: !0 },
                        ),
                        i.hide(!0))
                      : this.cart.renderContents(e);
                  } else window.location = window.routes.cart_url;
                })
                .catch((e) => {
                  console.error(e);
                })
                .finally(() => {
                  (this.submitButton.classList.remove("loading"),
                    this.cart &&
                      this.cart.classList.contains("is-empty") &&
                      this.cart.classList.remove("is-empty"),
                    this.error ||
                      this.submitButton.removeAttribute("aria-disabled"),
                    this.querySelector(
                      ".loading-overlay__spinner",
                    ).classList.add("hidden"),
                    freeShippMsg());
                }));
          }
        }
        handleErrorMessage(e = !1) {
          ((this.errorMessageWrapper =
            this.errorMessageWrapper ||
            this.querySelector(".pform-error-wrap")),
            this.errorMessageWrapper &&
              ((this.errorMessage =
                this.errorMessage ||
                this.errorMessageWrapper.querySelector(".pform-error-msg")),
              this.errorMessageWrapper.toggleAttribute("hidden", !e),
              e && (this.errorMessage.textContent = e)));
        }
      },
    ),
  freeShippMsg());
